(function () {
  var filterSelector = "[data-integer-range-filter]";
  var initializedAttribute = "data-integer-range-initialized";

  function clamp(value, min, max) {
    value = Number(value);
    if (Number.isNaN(value)) return min;
    return Math.min(Math.max(value, min), max);
  }

  function formatPercent(value) {
    return Math.round(value) + "%";
  }

  function initIntegerRangeFilter(container) {
    if (!container || container.hasAttribute(initializedAttribute)) return;

    var minInput = container.querySelector('[data-integer-range-bound="min"]');
    var maxInput = container.querySelector('[data-integer-range-bound="max"]');
    var sliderWrap = container.querySelector("[data-integer-range-slider]");
    var label = container.querySelector("[data-integer-range-label]");
    var checkboxes = Array.prototype.slice.call(container.querySelectorAll("[data-integer-range-value]"));

    if (!minInput || !maxInput || !sliderWrap || !checkboxes.length) return;

    container.setAttribute(initializedAttribute, "true");

    var min = Number(container.dataset.integerRangeMin);
    var max = Number(container.dataset.integerRangeMax);
    var activeMin = clamp(container.dataset.integerRangeActiveMin, min, max);

    sliderWrap.innerHTML =
      '<div class="integer-range-slider integer-range-slider--single">' +
        '<div class="integer-range-slider__labels">' +
          '<span>' + formatPercent(min) + '</span>' +
          '<span>' + formatPercent(max) + '</span>' +
        '</div>' +
        '<div class="integer-range-slider__control">' +
          '<div class="integer-range-slider__track"><div class="integer-range-slider__fill"></div></div>' +
          '<input class="integer-range-slider__input" type="range">' +
          '<span class="integer-range-slider__bubble"></span>' +
        '</div>' +
      '</div>';

    var slider = sliderWrap.querySelector(".integer-range-slider__input");
    var fill = sliderWrap.querySelector(".integer-range-slider__fill");
    var bubble = sliderWrap.querySelector(".integer-range-slider__bubble");

    slider.min = min;
    slider.max = max;
    slider.step = 1;

    function updateUI(value) {
      value = Math.round(clamp(value, min, max));

      minInput.value = value;
      maxInput.value = max;
      slider.value = value;

      if (label) {
        label.textContent = "Showing savings over " + formatPercent(value);
      }

      var percent = max === min ? 0 : ((value - min) / (max - min)) * 100;

      fill.style.left = percent + "%";
      fill.style.width = 100 - percent + "%";

      bubble.textContent = Math.round(value);
      bubble.style.left = percent + "%";
    }

    function applyCheckedState(value) {
      var changedInput = null;
      var isFullRange = value <= min;

      checkboxes.forEach(function (checkbox) {
        var checkboxValue = Number(checkbox.dataset.integerRangeValue);
        var shouldCheck = !isFullRange && checkboxValue >= value && !checkbox.disabled;

        if (checkbox.checked !== shouldCheck) {
          checkbox.checked = shouldCheck;
          changedInput = changedInput || checkbox;
        }
      });

      if (changedInput) {
        changedInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    function applyValue(value) {
      value = Math.round(clamp(value, min, max));
      updateUI(value);
      applyCheckedState(value);
    }

    slider.addEventListener("input", function () {
      updateUI(slider.value);
    });

    slider.addEventListener("change", function () {
      applyValue(slider.value);
    });

    minInput.addEventListener("change", function () {
      applyValue(minInput.value);
    });

    updateUI(activeMin);
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll(filterSelector)).forEach(initIntegerRangeFilter);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(filterSelector)) {
            initIntegerRangeFilter(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
    document.addEventListener(
    "click",
    function (event) {
      var clearAllButton = event.target.closest("[data-clear-all-filters]");

      if (!clearAllButton) return;

      var availabilityInput = Array.prototype.slice
        .call(document.querySelectorAll("[data-filter-item-input]"))
        .find(function (input) {
          return input.name && input.name.toLowerCase().indexOf("availability") !== -1;
        });

      if (!availabilityInput) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var clearUrl = clearAllButton.getAttribute("href") || window.location.pathname;
      var url = new URL(clearUrl, window.location.origin);

      url.searchParams.set(availabilityInput.name, availabilityInput.value || "1");

      window.location.href = url.toString();
    },
    true
  );
})();